var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderPlumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 111,
    viewBox: "0 0 108 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 107.48,
    height: 110.06,
    rx: 20,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1872 38C54.1872 38 43 56.0291 43 62.0707C43.0682 64.9926 44.2767 67.7718 46.3673 69.8142C48.4579 71.8566 51.2645 73 54.1872 73C57.1098 73 59.9165 71.8566 62.007 69.8142C64.0976 67.7718 65.3062 64.9926 65.3743 62.0707C65.3743 56.0291 54.1872 38 54.1872 38Z",
    fill: "#666666"
  })));
}
export default SvgPlaceholderPlumber;